<template>
    <div :class="['table', { 'expanded': bases.data.length <= 3 }]">
        <b-table hover :items="bases.data" :fields="fields" id="abonados-table">
            <template #cell(activo)></template>
            <template #cell(opciones)="{ item, index }">
                <OpcionesDropdownTableComponent
                    :lastIndex="bases.data.length > 3 && index >= bases.data.length - 3"
                    :options="[
                        { to: { name: 'back.bases.show', params: { base_id: item.id, lista_id: lista_id } }, label: 'Ver'},
                        ... item.user_id ?
                            [{ to: { name: 'back.usuarios.show-user', params: { lista_id: lista_id, user_id: item.user_id }}, label: 'Ver usuario'}]
                            : [],
                        { to: { name: 'back.bases.update', params: { base_id: item.id, lista_id: lista_id } }, label: 'Editar'},
                        { type: 'action', action:() => showModal('enviar-' + item.id), label: 'Enviar'},
                        { type: 'action', action: () => descargarPDF(item.url_pdf), label: 'Descargar Base' },
                        ... item.activo ? [
                            { type: 'action', action:() => showModal('anular-' + item.id), label: 'Realizar devolución'},
                        ] : [
                            { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'}
                        ],
                        { type: 'url', url: item.url_recibo + '&tid=' + configuracion.hash_teatro, label: 'Imprimir recibo'}
                    ]"
                />
                <EnviarBase :base="item" @close="closeModal"/>
                <AnularBase :base="item" @close="closeModal" @actualizado="actualizar"/>
                <BorrarModalComponent
                    :name="'borrar-' + item.id"
                    :title="'Borrar deportista ' + item.nombre"
                    confirmButton="¿Está segur@ de borrar este deportista?"
                    v-on:close="() => closeModal('borrar-' + item.id)"
                    v-on:confirm="() => borrarDeportista(item.id)"
                />
            </template>
            <template #cell(tipo)="{ item }">{{ item.metodo_pago == 5 || item.metodo_pago == 8 ? 'ONLINE' : 'TAQUILLA' }}</template>
        </b-table>
    </div>
</template>

<script>
    import EnviarBase from '../modals/EnviarBase.vue';
    import AnularBase from '../modals/AnularBase.vue';
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent.vue";

    export default {
        props: ['bases', 'lista_id'],
        data() {
            return {
                loading: false,
                fields: [
                    { key: 'activo', label: '', tdClass: this.estaRenovadoCellClass },
                    { key: "nombre", label: "Nombre" },
                    { key: "apellidos", label: "Apellidos" },
                    { key: "dni", label: "DNI" },
                    { key: "email", label: "Email" },
                    { key: "tipo", label: "Tipo" },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ],
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        methods: {
            showModal(modal) {
                this.$modal.show(modal);
            },
            actualizar() {
                this.$emit('actualizado');
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            estaRenovadoCellClass(value, key, item) {
                switch (value) {
                    case 1:
                        return 'bg-green';

                    default:
                        return 'bg-red';
                }
            },
            borrarDeportista(base_id) {
                const params = {
                    filters : {},
                    lista_id: this.lista_id,
                    base_id: base_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.actualizar();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
                this.closeModal('borrar-' + base_id);
            },

            descargarPDF(url) {
                window.open(url, '_blank');
            },
        },
        components: {
            OpcionesDropdownTableComponent, EnviarBase, AnularBase, BorrarModalComponent
        }
    }

</script>

<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>
